<div class="goal-row-inputs">
  <div class="goal-value-input-div">
    <input
      type="number"
      title="goal"
      class="form-control goal-value-input"
      [(ngModel)]="goalValue"
      [disabled]="goalInactive"
      (ngModelChange)="goalValueChanged.emit({ value: $event, id: id })"
    />
    <div class="data-suffix-div">{{ metric?.data_suffix }}</div>
  </div>
  <div class="checkbox-input-div">
    <mat-checkbox
      [checked]="goalInactive"
      (change)="goalInactiveChecked.emit({ value: $event.checked, id: id })"
      class="checkbox-input"
    ></mat-checkbox>
  </div>
</div>
